import axios from 'axios'
import router from '@/router'

import { Message, MessageBox } from 'element-ui'
// import { getAuthUrl } from '../api/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_DATA_URL,
  withCredentials: true,
  timeout: 50000 // 请求超时时间
})
export default service

service.interceptors.response.use(
  response => {
    const code = response.data.retCode
    const msg = response.data.retMsg

    if (code === 0) {
      return response.data
    }

    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })

    if (code === -2) {
      MessageBox.confirm(
        '你已被登出，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        axios.get(`${process.env.VUE_APP_DATA_URL}/auth/url`).then(({data}) => {
          window.location.href = data
        })
      })
    }

    if (code === -3) {
      router.push(
        {path: '/ban'}
      )
    }

    return response.data
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.response.data,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

/*
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, //
  timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {

    const res = response.data
    if (res.code !== 20000) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
*/



// WEBPACK FOOTER //
// ./src/utils/request.js